import DataRoomSetup from './DataRoomSetup.component';

export default DataRoomSetup;
